const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/ECheckinCard/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        cardTitle: 'Online Check-in',
        echeckinWasFinalized: 'Sie haben das Online Check-in erfolgreich abgeschlossen.',
        echeckinWasFinalizedAndGoToCounter:
            'Sie haben das Online Check-in erfolgreich abgeschlossen. Bitte gehen Sie zum Schalter um ihre Registration abzuschliessen.',
        noOpenEcheckin: 'Sie haben zurzeit kein offenes Online Check-in.',
        termStartText: 'Termin: {date}, um {time} Uhr',
        beginBtn: 'Online Check-in starten',
        continueBtn: 'Online Check-in fortsetzen',
        entry: 'Eintritt',
        doneWorkItems: '{count, plural, one {# erledigtes Online Check-in} other {# erledigte Online Check-ins}}',
        hideDoneWorkItems: 'Erledigte verbergen',
        hiddenAppointmentText: 'Bitte füllen Sie das Online Check-in vor Ihrem Termin aus.',
        caseNumber: 'Fallnummer:',
        caseType: 'Fallart:',
        ambulant: 'Ambulant',
        stationary: 'Stationär',
        hiddenAppointmentTextFinalized: 'Check-in abgeschlossen am {date}, um {time} Uhr',
    },
    __RELATIVE_SOURCE_FILE__
);
